import { CSSProperties } from "@material-ui/core/styles/withStyles";

export const container: CSSProperties = {
  display: "flex",
  padding: "100px 10%",
  minHeight: 700,
  height: "100%",
  "@media (max-width: 768px)": {
    flexDirection: "column",
    alignItems: "center",
    padding: "40px 20px",
    minHeight: 400,
    gap: 20,
  },
};

export const content: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  flexShrink: 0,
  width: "40%",
  "@media (max-width: 768px)": {
    textAlign: "center",
    order: 2,
    width: "100%",
  },
};

export const img: CSSProperties = {
  display: "inline-block",
  flexGrow: 1,
  maxWidth: 300,
  marginLeft: "auto",
  "@media (max-width: 768px)": {
    flexGrow: 0,
    maxWidth: 150,
    marginLeft: 0,
  },
};

export const styles = {
  container,
  content,
  img,
};
